(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
function loadRnlRecommendations() {
 const root = document.querySelector('#related .product-recommendations');
 if (!root) return;
 const url = '/recommendations/products?section_id=product-recommendations&limit=' + root.dataset.limit + '&product_id=' + root.dataset.productId;
 fetch(url).then(response => { if (!response.ok) throw new Error('Unavailable'); return response.text(); }).then(html => {
  const fragment = new DOMParser().parseFromString(html, 'text/html');
  const recommendations = fragment.querySelector('.product-recommendations');
  if (recommendations && recommendations.innerHTML.trim()) root.innerHTML = recommendations.innerHTML;
  else root.closest('section').hidden = true;
 }).catch(() => { root.closest('section').hidden = true; });
}
loadRnlRecommendations();
document.addEventListener('shopify:section:load', event => { if (event.detail.sectionId === 'product-recommendations') loadRnlRecommendations(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-product"]) return;
  try {
    
(() => {
function firstArrivalImage(root) {
  if (!root || root.dataset.rlArrivalReady) return;
  root.dataset.rlArrivalReady = 'true';
  let interacted = false;
  const release = () => {
    interacted = true;
    root.dataset.rlGalleryInteracted = 'true';
  };
  root.addEventListener('change', event => {
    if (event.target.closest('.product_form')) release();
  }, true);
  const gallery = root.querySelector('[data-product-gallery]');
  if (gallery) gallery.addEventListener('click', event => {
    if (event.target.closest('.product-thumbnail,.next-image,.prev-image')) release();
  }, true);
  const mobile = root.querySelector('#mobile-product-photos');
  if (mobile) {
    mobile.addEventListener('pointerdown', release, {once:true, passive:true});
    mobile.addEventListener('touchstart', release, {once:true, passive:true});
  }
  const showFirst = () => {
    if (interacted || !root.isConnected) return;
    const first = root.querySelector('.product-thumbnail');
    if (first) first.click();
    if (mobile && window.jQuery) {
      const carousel = window.jQuery(mobile).data('owlCarousel');
      if (carousel) carousel.jumpTo(0);
    }
  };
  if (document.readyState === 'complete') showFirst();
  else window.addEventListener('load', showFirst, {once:true});
}
  const mount = root => {
    if (root.dataset.rlMounted) return;
    const form = root.querySelector('.product_form');
    if (!form) return;
    const product = JSON.parse(form.querySelector('.product-json').textContent);
    const data = JSON.parse(root.querySelector('.rl-presentation-data').textContent);
    const labels = JSON.parse(root.querySelector('.rl-product-labels').textContent);
    const original = form.querySelector('select[name="id"]');
    const options = Array.from(form.querySelectorAll('.single-option-selector'));
    if (product.variants.length > 1 && options.length !== product.options.length) return;
    root.dataset.rlMounted = 'true';
    firstArrivalImage(root);
    const abort = new AbortController();
    const signal = abort.signal;
    const wrapper = document.createElement('div');
    wrapper.className = 'rl-variant-control';
    const label = document.createElement('label');
    const select = document.createElement('select');
    select.className = 'rl-combined-select';
    select.id = 'rl-variant-' + product.id;
    label.htmlFor = select.id;
    const selectorLabel = data.selector_label || labels.choose;
    label.textContent = selectorLabel;
    select.setAttribute('aria-label', selectorLabel);
    product.variants.forEach(variant => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.options.join(' — ');
      select.appendChild(option);
    });
    const hint = document.createElement('p');
    hint.className = 'rl-format-hint';
    hint.id = 'rl-hint-' + product.id;
    hint.setAttribute('aria-live', 'polite');
    select.setAttribute('aria-describedby', hint.id);
    const updateHint = variant => {
      const format = variant.options.find(value => /^(decant|full bottle)$/i.test(value));
      const signatureSize = variant.options.some(value => /^(3|4|6|12)\s*ml$/i.test(value.trim()));
      hint.textContent = format ? (/^decant$/i.test(format) ? labels.decant : labels.bottle) : (signatureSize ? labels.decant : '');
      hint.hidden = !hint.textContent;
    };
    select.value = original ? original.value : product.variants[0].id;
    updateHint(product.variants.find(v => String(v.id) === select.value) || product.variants[0]);
    select.addEventListener('change', () => {
      const variant = product.variants.find(v => String(v.id) === select.value);
      options.forEach((option, i) => { option.value = variant.options[i]; });
      if (options.length) options[options.length - 1].dispatchEvent(new Event('change', {bubbles: true}));
      else if (original) original.value = variant.id;
      updateHint(variant);
    }, {signal});
    wrapper.append(label, select, hint);
    const purchase = form.querySelector('#product-add');
    const price = form.querySelector('#product-price');
    form.insertBefore(wrapper, price || purchase);
    options.forEach(option => { option.closest('.selector-wrapper').hidden = true; option.closest('.selector-wrapper').style.display = 'none'; });
    if (original) original.style.display = 'none';
    if (price && purchase) purchase.before(price);
    const area = root.querySelector('#product-description');
    const title = area.querySelector(':scope > h1');
    const status = document.createElement('span');
    status.className = 'rl-wishlist-feedback';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    area.appendChild(status);
    let previous = null, timer;
    const sync = () => {
      const buttons = Array.from(root.querySelectorAll('button.wk-button-product'));
      if (!buttons.length) return;
      const button = buttons.find(b => b.parentNode !== area) || buttons[buttons.length - 1];
      buttons.forEach(b => { if (b !== button) b.remove(); });
      if (button.parentNode !== area) area.appendChild(button);
      const saved = button.classList.contains('wk-remove-product');
      button.setAttribute('aria-label', saved ? labels.remove : labels.add);
      button.setAttribute('aria-pressed', String(saved));
      button.style.top = title.offsetTop + 'px';
      status.style.top = title.offsetTop + 47 + 'px';
      if (previous !== null && previous !== saved) {
        status.textContent = saved ? labels.added : labels.removed;
        clearTimeout(timer);
        timer = setTimeout(() => { status.textContent = ''; }, 2200);
      }
      previous = saved;
    };
    const observer = new MutationObserver(sync);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
    window.addEventListener('resize', sync, {signal});
    sync();
    if (document.fonts) document.fonts.ready.then(() => { if (root.isConnected) sync(); });
    root.rlCleanup = () => { observer.disconnect(); abort.abort(); clearTimeout(timer); };
  };
  const init = () => document.querySelectorAll('.rl-product-v1').forEach(root => {
    mount(root);
    if (!root.dataset.rlMounted && !root.rlPending) {
      root.rlPending = new MutationObserver(() => {
        mount(root);
        if (root.dataset.rlMounted) { root.rlPending.disconnect(); root.rlPending = null; }
      });
      root.rlPending.observe(root, {childList: true, subtree: true});
    }
  });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init, {once: true});
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.rl-product-v1').forEach(root => { root.rlPending?.disconnect(); root.rlCleanup?.(); }));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
function initRnlTestimonials(root) {
  root.querySelectorAll('.rnl-testimonials').forEach(section => {
    if(section.dataset.ready) return;
    section.dataset.ready='true';
    const track=section.querySelector('.rnl-testimonials__track');
    const cards=track.querySelectorAll('.rnl-testimonials__card');
    const buttons=section.querySelectorAll('[data-rnl-direction]');
    const position=section.querySelector('.rnl-testimonials__position');
    const refresh=()=>{
      const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
      const index=Math.round(track.scrollLeft/step);
      position.textContent=(index+1)+' / '+cards.length;
      buttons[0].disabled=track.scrollLeft<2;
      buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;
    };
    buttons.forEach(button=>button.addEventListener('click',()=>{
      const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
      track.scrollBy({left:Number(button.dataset.rnlDirection)*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }));
    const dialog=section.querySelector('.rnl-testimonials__dialog');
    section.querySelector('.rnl-testimonials__dialog-close').addEventListener('click',()=>dialog.close());
    section.querySelectorAll('.rnl-testimonials__more').forEach(button => {
      const card=button.closest('.rnl-testimonials__card');
      const quote=card.querySelector('blockquote');
      const check=()=>{button.hidden=quote.scrollHeight<=quote.clientHeight+2;};
      button.addEventListener('click',()=>{
        dialog.querySelector('h3').textContent=card.querySelector('h3')?.textContent||'Client review';
        dialog.querySelector('blockquote').textContent=quote.textContent;
        dialog.querySelector('.rnl-testimonials__dialog-author').textContent=card.querySelector('.rnl-testimonials__author')?.textContent||'';
        dialog.querySelector('.rnl-testimonials__dialog-stars').setAttribute('aria-label',card.querySelector('.rnl-testimonials__stars')?.getAttribute('aria-label')||'5 out of 5 stars');
        dialog.showModal();
      });
      requestAnimationFrame(check);
      window.addEventListener('resize',check);
    });
    track.addEventListener('scroll',refresh,{passive:true});
    window.addEventListener('resize',refresh);
    refresh();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initRnlTestimonials(document));}else{initRnlTestimonials(document);}
document.addEventListener('shopify:section:load',()=>initRnlTestimonials(document));

  } catch(e) { console.error(e); }
})();
})();
